<div class="container-body">
    <div class="container-shadow">
        <div class="container">
            <div class="right-side-content">
                <div class="block">
                    <button class="help_block-border">
                        <div class="help_block-colored" style="background-color: rgba(236, 253, 255, 1);">
                            <h3 class="title">Основное меню</h3>
                        </div>
                    </button>
                    <div class="items-column">
                        <div class="item" (click)="goHome()">
                            <mat-icon class="icon clickable" svgIcon="home1"></mat-icon>
                            <p class="item-title">Главная</p>
                        </div>
                        <div class="item" (click)="handleNavigationClick()">
                            <mat-icon class="icon clickable" svgIcon="elements-list"></mat-icon>
                            <p class="item-title">Содержание</p>
                        </div>
                        <div class="item" (click)="handleQuestionClick()">
                            <mat-icon class="icon clickable" svgIcon="question"></mat-icon>
                            <p class="item-title">Техподдержка</p>
                        </div>
                        <div class="item" *ngIf="showResetBtn" (click)="handleCatClick()">
                            <mat-icon class="primary-icon icon clickable" svgIcon="cat"></mat-icon>
                            <p class="item-title">Сбросить курс</p>
                        </div>
                    </div>
                </div>

                <div class="block">
                    <button class="help_block-border">
                        <div class="help_block-colored">
                            <h3 class="title">Мои достижения</h3>
                        </div>
                    </button>
                    <div class="items-row">
                        <div class="item">
                            <div class="item-icon"></div>
                        </div>
                        <div class="item">
                            <div class="item-icon"></div>
                        </div>
                        <div class="item">
                            <div class="item-icon"></div>
                        </div>
                    </div>
                </div>

                <div class="block" (click)="logout()" color="primary">
                    <button class="help_block-border">
                        <div class="help_block-colored">
                            <mat-icon class="icon logout"svgIcon="power"></mat-icon>
                            <h3 class="title logout">Выход из тренажера</h3>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>